module.exports = __webpack_public_path__ + "img/startseite.7ceb76ba.png";